// extracted by mini-css-extract-plugin
module.exports = {"container":"panel-aside_container__5ol_C","opened":"panel-aside_opened__ZL2_7","skeleton_animate":"panel-aside_skeleton_animate__V7xW6"};